package br.com.texeratx.boardgametimeapp.data.model.dashboard

import kotlinx.serialization.Serializable

@Serializable
data class DashboardGameDTO(
    val gameId: Long,
    val name: String,
    val imageUrl: String?,
    val count: Int     // número de partidas no período
)
